import React from "react";
import { Grid2 } from "@mui/material";
import styles from "./FailedPage.module.scss";
import { ReactComponent as DomainFailed } from "../../../../../../../../GlobalAssets/svg/DomainFailed.svg";

export default function FailedPage({ message }) {
  return (
    <Grid2 className={styles.FailedPageContainer}>
      <Grid2 className={styles.header}>Something went wrong</Grid2>
      {message && <Grid2 className={styles.message}>{message}</Grid2>}
      <Grid2>
        <DomainFailed />
      </Grid2>
    </Grid2>
  );
}
